export default __webpack_public_path__ + "85fef0e96489304f7491b1fb694fa953.png";